import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider } from './lib/auth'
import { inicializarSentry, SentryErrorBoundary } from './lib/sentry'
import './index.css'

inicializarSentry()

function FallbackErro({ error, resetError }: { error: unknown; resetError: () => void }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-anamis-50 px-6">
      <div className="max-w-md text-center">
        <div className="text-6xl mb-3">😣</div>
        <h1 className="text-2xl font-extrabold text-slate-900 mb-2">Algo deu errado</h1>
        <p className="text-slate-600 mb-4">
          A gente já recebeu o aviso e vai investigar. Tente recarregar a página.
        </p>
        {import.meta.env.DEV && (
          <pre className="text-xs text-left bg-slate-100 rounded-lg p-3 mb-4 overflow-auto">
            {String(error)}
          </pre>
        )}
        <button
          onClick={() => { resetError(); window.location.reload() }}
          className="btn-primary"
        >
          Recarregar
        </button>
      </div>
    </div>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SentryErrorBoundary fallback={(props) => <FallbackErro {...props} />} showDialog={false}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </SentryErrorBoundary>
  </StrictMode>,
)

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', async () => {
    try {
      const reg = await navigator.serviceWorker.register('/sw.js')
      // Verifica nova versão a cada minuto
      setInterval(() => reg.update().catch(() => {}), 60_000)
      reg.addEventListener('updatefound', () => {
        const w = reg.installing
        if (!w) return
        w.addEventListener('statechange', () => {
          if (w.state === 'installed' && navigator.serviceWorker.controller) {
            // Nova versão pronta — atualiza silenciosamente
            w.postMessage({ type: 'SKIP_WAITING' })
          }
        })
      })
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload()
      })
    } catch (e) {
      console.warn('[sw] reg', e)
    }
  })
}
